import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SpecificationService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI4 + "/api/productSpecification";

  url1 = environment.serverAPI4 + "/api/ig/productSpecification";

  url2 = environment.serverAPI4 + "/api/lecturerIdx";

  AddEditSpecification(specification: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, specification)
  }

  getSpecificationId(specificationId: number): Observable<Object> {
    return this.http.get(`${this.url1}/${specificationId}`);
  }

  Specification(Page: number, size: number, sort): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  SpecificationSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteImage(data: any): Observable<Object> {
		return this.http.post(`${this.url}/deleteImage`, data);
	}

  getAllSpecification(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getLecturerById(id: number): Observable<Object> {
    return this.http.get(`${this.url2}/${id}`);
  }

}
